import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const HeroSection = () => {
  return <section className="pb-16 pt-24 md:py-24 bg-gradient-to-b from-brand-lightBlue to-white overflow-hidden">
      <div className="container">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="md:w-1/2 space-y-6">
            <div>
              <p className="text-brand-blue font-medium mb-2">Over Afsprakenmaker.be</p>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Jouw partner voor effectieve <span className="text-brand-blue">telemarketing</span>
              </h1>
            </div>
            
            <p className="text-lg md:text-xl text-gray-700">Sinds 2012 helpen wij bedrijven in België groeien door kwalitatieve afspraken in te plannen met potentiële klanten. Onze focus ligt op persoonlijk contact en bewezen resultaat.</p>
            
            <div className="flex flex-wrap gap-4 pt-2">
              <Button className="group" asChild>
                <Link to="/diensten">
                  Ontdek onze diensten
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              <Button variant="outline" scrollToId="team">
                Ontmoet het team
              </Button>
            </div>
          </div>
          
          <div className="md:w-1/2 relative">
            <div className="relative z-10 rounded-lg overflow-hidden shadow-xl max-w-[65%] mx-auto">
              <img src="/lovable-uploads/524a17f8-3eb4-4878-bb04-50ed8fa4b4a9.png" alt="Trends Gazellen" className="w-full h-auto object-cover" width="600" height="400" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-brand-blue rounded-full opacity-20 z-0"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-brand-red rounded-full opacity-10 z-0"></div>
          </div>
        </div>
        
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-brand-blue">14+</p>
            <p className="text-gray-600">Jaren ervaring</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-brand-blue">750+</p>
            <p className="text-gray-600">Tevreden klanten</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-brand-blue">150.000+</p>
            <p className="text-gray-600">Gemaakte afspraken</p>
          </div>
          <div className="text-center">
            <p className="text-3xl md:text-4xl font-bold text-brand-blue">90%</p>
            <p className="text-gray-600">Klanttevredenheid</p>
          </div>
        </div>
      </div>
    </section>;
};
export default HeroSection;